module.exports = __webpack_public_path__ + "media/images/robot_default-f5e11ec4.svg";